// Shared "field-level changes awaiting approval" block for master records (suppliers/customers/BOM).
// Renders the planner-edit diff (pending_changes) as old → new rows; null when there is no diff.
import { typeLabel } from "@/lib/itemTypes";

export const SUPPLIER_LABELS = {
  name: "Name", gst_tax_id: "GST / Tax ID", contact_person: "Contact Person", phone: "Phone",
  email: "Email", address: "Address", categories: "Categories", payment_terms: "Payment Terms",
  default_lead_time_days: "Default Lead Time (days)", notes: "Notes",
};

export const CUSTOMER_LABELS = {
  name: "Name", gst_tax_id: "GST / Tax ID", contact_person: "Contact Person", phone: "Phone",
  email: "Email", address: "Address", categories: "Categories", payment_terms: "Payment Terms",
  credit_limit: "Credit Limit", notes: "Notes",
};

export const BOM_LABELS = {
  name: "Name", sku: "SKU", item_type: "Type", unit: "Unit", image_url: "Image",
  components: "Recipe", stages: "Stages", stock_quantity: "Stock", min_stock: "Reorder Level",
  supplier: "Preferred Supplier", category: "Category", lead_time_days: "Lead Time (days)",
  pack_size: "Pack Size", moq: "MOQ", line_id: "Production Line",
};

export function ChangeDiff({ changes, labels = {}, testidPrefix }) {
  const entries = Object.entries(changes || {});
  if (entries.length === 0) return null;
  const fmt = (f, v) => {
    if (f === "item_type") return typeLabel(v);
    if (v === null || v === undefined || v === "") return "—";
    if (Array.isArray(v)) {
      if (v.length === 0) return "—";
      return typeof v[0] === "object" ? `${v.length} item(s)` : v.join(", ");
    }
    if (typeof v === "number") return v.toLocaleString("en-IN");
    return String(v);
  };
  return (
    <div className="mt-1 rounded-md border border-yellow-300 bg-yellow-50 px-2 py-1.5 space-y-0.5" data-testid={`${testidPrefix}-changes`}>
      <p className="text-[9px] uppercase tracking-wide text-yellow-700 font-semibold">Changed Fields · Vs Active Version</p>
      {entries.map(([f, ch]) => (
        <p key={f} className="text-[10px] font-mono-data" data-testid={`${testidPrefix}-change-${f}`}>
          <span className="text-slate-500 font-medium">{labels[f] || f}: </span>
          <span className="line-through text-slate-400">{fmt(f, ch?.old)}</span>
          <span className="text-slate-400"> → </span>
          <span className="bg-yellow-200 text-yellow-900 px-0.5 rounded font-semibold">{fmt(f, ch?.new)}</span>
        </p>
      ))}
    </div>
  );
}
